import './bootstrap';
import '../css/app.css';
import {
   QueryClientProvider,
} from '@tanstack/react-query'
import { createRoot } from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { queryClient } from './lib/query';
import { Toaster as RHToaster } from 'react-hot-toast';
import { Toaster } from "@/components/ui/sonner"

// import { Toaster } from './Components/ui/toaster';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

createInertiaApp({
   title: (title) => `${title} - ${appName}`,
   resolve: (name) => resolvePageComponent(`./pages/${name}.jsx`, import.meta.glob('./pages/**/*.jsx')),
   setup({ el, App, props }) {
      const root = createRoot(el);

      root.render(
         <QueryClientProvider client={queryClient}>
            <App {...props} />
            <Toaster  />
            <RHToaster
            position="top-center"
            reverseOrder={false}
            />
         </QueryClientProvider>
      );
   },
   progress: {
      color: '#039746',
   },
});
